<section class="flex flex-col gap-8">
	<div class="flex gap-4 mb-4">
		<div class="w-48 h-48 p-8 flex-shrink-0">
			<img
				src="assets/images/integrations/sync-logo.png"
				alt="Sync by Closer Logo"
			/>
		</div>
		<div class="flex flex-col gap-4">
			<h3 class="h3">Please Enter Your PIN</h3>
			<p class="p-lg">
				We just want to make sure its you authorizing this action.
			</p>
			<form [formGroup]="form" (ngSubmit)="validatePin()">
				<div class="flex flex-col gap-4">
					<app-input
						name="pin"
						formControlName="pin"
						type="password"
						placeholder="1234"
						label="Enter your PIN"
						required
					></app-input>

					<div class="flex flex-1 justify-end mt-6">
						<ui-button label="Confirm" type="submit" [loading]="loading" />
					</div>
				</div>
			</form>
		</div>
	</div>
</section>
